import * as runtypes from 'runtypes'

export type FormValues = runtypes.Static<typeof FormValuesRuntype>

export const FormValuesRuntype = runtypes.Record({
  name: runtypes.String,
  email: runtypes.String,
  subject: runtypes.String,
  details: runtypes.String,
})
